import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

/**
 * Betrun şemasının oyun kartı: görselin altında oyun adı ve sağlayıcı.
 *
 * Merit kartının kopyasıdır; ayrım görselin üzerindeki "Oyna" düğmesidir.
 * Şema oyunu seçim penceresi açmadan başlatır (bkz.
 * hooks/useGameLauncher.js `directLaunch`), bu yüzden kart oyunu açacağını
 * kendi üzerinde söyler: masaüstünde üzerine gelince, dokunmatik ekranda
 * (hover yok) her zaman görünür. Renkler tema değişkenlerinden gelir.
 */
const BetrunGameCard = ({ game, onPlay }) => {
  const play = () => onPlay?.(game);

  return (
    <div {...hook(HOOKS.GAME_CARD)} className="betrun-card" onClick={play} role="button" tabIndex={0}
         onKeyDown={(event) => { if (event.key === 'Enter') play(); }}>
      <div className="betrun-card-art">
        {game.new && (
          <span className="betrun-card-badge" style={{ background: 'var(--pusu-gold)', color: 'var(--pusu-on-accent)' }}>
            YENİ
          </span>
        )}
        {!game.new && game.hot && (
          <span className="betrun-card-badge" style={{ background: '#c62e31' }}>POPÜLER</span>
        )}
        <GameArtwork src={game.img || game.image} alt={game.name} />
        <span className="betrun-card-play">
          <span className="betrun-card-cta">
            <Play size={13} fill="currentColor" />
            Oyna
          </span>
        </span>
      </div>
      <div className="betrun-card-name">{game.name}</div>
      <div className="betrun-card-provider">{game.provider}</div>
    </div>
  );
};

export default BetrunGameCard;
